import borders from './Borders';
import breakpoints from './Breakpoints';
import colors from './Colors';
import fonts from './Fonts';
import gridConfig from './GridConfig';
import inverseTheme from './inverse';
import shadows from './Shadows';
import typography from './Typography';
import zIndex from './ZIndex';

const theme = {
  borders,
  breakpoints,
  colors,
  fonts,
  gridConfig,
  shadows,
  typography,
  zIndex,
};

const inverse = { ...theme, ...inverseTheme };

// eslint-disable-next-line no-restricted-exports
export { theme as default, inverse };
